







import { Vue, Prop, Component } from 'vue-property-decorator';
import VimeoVideoModal from './VimeoVideoModal.vue';
@Component
export default class VimeoVideoModalToggle extends Vue {
    @Prop() video!: string;
    expanded: boolean = false;

    toggleModal() {
        this.$modal.show(
            VimeoVideoModal,
            {
                videoUrl: this.video
            },
            {
                adaptive: true,
                maxWidth: 1500,
                scrollable: false
            }
        );
    }
}
